import { create } from "zustand";

interface SongStoreIFace {
  songDetails: any;
  setSongDetails: (songDetails: any) => void;

  toneCode: any;
  setToneCode: (toneCode: any) => void;
}

const useSongStore = create<SongStoreIFace>((set) => ({
  songDetails: null,
  setSongDetails: (songDetails) => set({ songDetails }),

  toneCode: null,
  setToneCode: (toneCode) => set({ toneCode }),
}));

export default useSongStore;
